// Initialize MercadoPago SDK (side-effect import)
import "@/lib/mercadopago";

import { Wallet } from "@mercadopago/sdk-react";

interface Props {
  preferenceId: string;
}

export function MercadoPagoWalletBrick({ preferenceId }: Props) {
  return (
    <Wallet
      initialization={{ preferenceId, redirectMode: "modal" }}
      customization={{
        texts: { valueProp: "smart_option" },
      }}
      onError={(error) => {
        console.error("[MercadoPago Wallet Brick]", error);
      }}
    />
  );
}
